export default "__VITE_ASSET__tXHbLgIK__"